export default "__VITE_ASSET__BzcGsGSf__"